import { useMemo } from "react";
import { ApiResponse, ConditionData } from "components/Conditions/types";
import useApiResult from "../services/index";
import { getConditionsByExternalIdProgramId } from "../services/conditionsService";

// if adding authorized conditions, add in both objects
export const AUTHORIZED_CONDITION_READABLE_TEXT = {
  END005: "Diabetes (Type 2)",
  CIR007: "Hypertension",
};

export const nonRelevantConditionText = `Prospect is not confirmed to have the following conditions: ${Object.values(
  AUTHORIZED_CONDITION_READABLE_TEXT,
).join(", ")}; but may have these and other relevant conditions`;

const AUTHORIZED_CONDITIONS = [
  "END005", // DIABETES_TYPE_2
  "CIR007", // HYPERTENSION
];

export const formatConditionNames = (
  conditionData: ConditionData[],
): Set<string> => {
  const retrievedConditionNames: string[] = [];
  conditionData.forEach((condition) => {
    if (AUTHORIZED_CONDITIONS.includes(condition.code)) {
      retrievedConditionNames.push(condition.name);
    }
  });

  return new Set(retrievedConditionNames);
};

export const useConditionsByExternalIdProgramId = (
  externalId: string,
  programId: string,
): { conditionNames: Set<string>; error: string | null } => {
  const request = useMemo(
    () => {
      if (!externalId || !programId) {
        return null;
      }
      return getConditionsByExternalIdProgramId(externalId, programId);
    },
    [externalId, programId],
  );

  const [result, error] = <[ApiResponse, string | null]>(
    useApiResult(request)
  );

  let retrievedConditionNames: Set<string> = new Set();
  if (result?.success && result.data) {
    retrievedConditionNames = formatConditionNames(result.data);
  }

  return { conditionNames: retrievedConditionNames, error };
};

const useConditions = {
  useConditionsByExternalIdProgramId,
};

export default useConditions;
